import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { RentalApplicationQuestionnaireSettingsRepository } from '~/repositories/settings/rentalApplicationQuestionnaireSettingsRepository';
import type { IQuestionnaireSettingsDto } from '~/types/generalQuestions';

export const [RentalApplicationQuestionnaireSettingsProvider, useRentalApplicationQuestionnaireSettings] = createMagicDoorContext(
  'RentalApplicationQuestionnaireSettings',
  () => {
    const repo = new RentalApplicationQuestionnaireSettingsRepository();
    const [questionnaireSettings, setQuestionnaireSettings] = createSignal<IQuestionnaireSettingsDto | undefined>(undefined);
    const [isLoading, setIsLoading] = createSignal<boolean>(false);
    const [error, setError] = createSignal<Error | undefined>(undefined);

    const getRentalApplicationQuestionnaireSettings = async (): Promise<IQuestionnaireSettingsDto | undefined> => {
      setIsLoading(true);
      try {
        const result = await repo.getRentalApplicationQuestionnaireSettings();
        setQuestionnaireSettings(result);
        return result;
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setIsLoading(false);
      }
    };

    const updateRentalApplicationQuestionnaireSettings = async (
      payload: IQuestionnaireSettingsDto
    ): Promise<IQuestionnaireSettingsDto | undefined> => {
      setIsLoading(true);
      try {
        const result = await repo.updateRentalApplicationQuestionnaireSettings(payload);
        setQuestionnaireSettings(result);
        return result;
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
        throw err;
      } finally {
        setIsLoading(false);
      }
    };

    return {
      isLoading,
      error,
      questionnaireSettings,
      getRentalApplicationQuestionnaireSettings,
      updateRentalApplicationQuestionnaireSettings,
    };
  }
);
